import {
  getBlogList,
  pathCreateBlog,
  pathDeleteBlog,
} from "../constants/apiRoutes";

import apiService from "../utils/configAxios";
import { blogActions } from "../reducers/blog";
import { toast } from "react-toastify";
import { t } from "i18next";

export const fetchBlogList = (id_blog = 0) => {
  return (dispatch) => {
    return apiService
      .get(getBlogList(id_blog))
      .then((response) => {
        id_blog == 0
          ? dispatch(blogActions.fetchBlogList(response.data))
          : dispatch(blogActions.fetchBlogDetail(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const createNewBlog = (data, navigate) => {
  return async () => {
    try {
      await apiService.postMultipart(pathCreateBlog(), data);
      navigate("/blog-list");
      toast.success(t("blogListActions.created"), { theme: "colored" });
    } catch (err) {
      handleError(err);
    }
  };
};

export const createNewBlog1 = (data, navigate) => {
  return (dispatch) => {
    return apiService
      .postMultipart(pathCreateBlog(), data)
      .then((response) => {
        // dispatch(blogActions.fetchBlogList(response.data));
        toast.success("Uspešno ste kreirali novu kompaniju", {
          theme: "colored",
        });
        navigate("/blog-list");
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchEditBlog = (data, navigate) => {
  return (dispatch) => {
    return apiService
      .putMultipart(pathCreateBlog(), data)
      .then((response) => {
        // dispatch(blogActions.fetchBlogList(response.data));
        toast.success(t("blogListActions.updated"), {
          theme: "colored",
        });
        navigate("/blog-list");
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchDeleteBlog = (id) => {
  return (dispatch) => {
    return apiService
      .delete(pathDeleteBlog(id))
      .then((response) => {
        toast.success(t("blogListActions.deleted"), {
          theme: "colored",
        });

        dispatch(fetchBlogList(0));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

const handleError = (err) => {
  let errorMessage = err.response ? err.response.data.message : err;
  if (!err.response) {
    toast.error(t("actions.error.refreshPage") + err.response, {
      theme: "colored",
    });
  }
  toast.error(errorMessage, { theme: "colored" });
};
